import { JobPlanOptionLocationAttribute } from "././attribute";

export class JobPlanOptionLocation {
    public id: number;
    public jobPlanOptionId: number;
    public locationGroupCommunityId: number;
    public locationCommunityId: number;
    public locationName: string;
    public locationGroupLabel: string;
    public quantity: string;
    public attributes: JobPlanOptionLocationAttribute[];
    public lastModifiedUtcDate: Date;
    public lastModifiedBy: string;
}